<template>
  <div>
    <div>
      <payment-data-form :schema="$schema.data.contractor" />

      <w-input class="form-group" :model="$schema.data.contractorId" />

      <w-input class="form-group" :model="$schema.data.contractorAddressId" />

      <w-input class="form-group" :model="$schema.data.contractorBankAccountId" />
    </div>

    <div class="d-flex justify-content-between mt-5">
      <w-button text="Anuluj" class="btn-secondary" @click="$emit('close')" />

      <w-button text="Zapisz" class="btn-primary" @click="saveData" />
    </div>
  </div>
</template>

<script>
import PaymentDataForm from '@/components/forms/PaymentDataForm.vue';
import { paymentDetailsEditMixin } from '@/mixins/paymentDetailsEdit';
import schema from '@/schemas/paymentDataWithIds.schema';

export default {
  components: { PaymentDataForm },
  mixins: [paymentDetailsEditMixin],
  schema
};
</script>
